import { z } from "zod";

/**
 * The author of the *incoming* candidate value of an in-field resolution target
 * (the "theirs" side of a mine/theirs conflict), plus which side of the
 * negotiation it originates from.
 *
 * - `Counterparty` — a cross-party redline the other party published to us.
 * - `Reviewer` — an intra-party blue-line a reviewer on our own party proposed,
 *   surfaced to that party's team leader.
 *
 * This is presentation metadata attached to a `FieldRedline` so the resolution
 * UI can label who proposed the change. It lives in the redlining layer so the
 * redline model never has to import from the negotiation contract (which already
 * depends on redlining).
 */
export const ResolutionIncomingAuthorOriginZ = z.enum(["Counterparty", "Reviewer"]);
export type ResolutionIncomingAuthorOrigin = z.infer<typeof ResolutionIncomingAuthorOriginZ>;

export const ResolutionIncomingAuthorZ = z.object({
  origin: ResolutionIncomingAuthorOriginZ,
  role: z.string().nullish(),
  userId: z.string().nullish(),
  legalEntityId: z.string().nullish(),
});
export type ResolutionIncomingAuthor = z.infer<typeof ResolutionIncomingAuthorZ>;
